import slice from '../reducer/slice';
import { IProps } from '../types/notice';

type TOperation = (props?: IProps) => void;

const { setError } = slice.actions;

const operation: TOperation = (props) => setError(props);

export default operation;
